import React from "react";
import { SITE } from "@/config/site";

// Official VS logo mark. Use `tile` on dark backgrounds (white chip behind the mark).
export function VsMark({ className = "h-9 w-9", tile = false }) {
  return (
    <img
      src={SITE.platformLogo}
      alt={`${SITE.brand} logo`}
      className={`${className} object-contain ${tile ? "rounded-lg bg-white p-0.5" : ""}`}
      data-testid="vs-logo-mark"
    />
  );
}
